var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBoxMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 19,
    height: 19,
    rx: 4.5,
    fill: "#121212",
    stroke: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00202 11.9972C8.00202 12.5502 8.45002 12.9972 9.00202 12.9972L15.002 12.9972C15.554 12.9972 16.002 12.5502 16.002 11.9972C16.002 11.4442 15.554 10.9972 15.002 10.9972L9.00202 10.9972C8.45002 10.9972 8.00202 11.4442 8.00202 11.9972Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxMinus);
export default __webpack_public_path__ + "static/media/CheckBoxMinus.622ea6a4a739c6d9b70392baa081884f.svg";
export { ForwardRef as ReactComponent };